import type { ColumnDef, PricingRule } from '@talos/kyoko';

export const CUSTOMER_SUB_ACCOUNT_MAPPINGS_COLUMNS: ColumnDef<PricingRule>[] = [
  { type: 'counterparty', field: 'Counterparty', initialHide: true },
  { type: 'security', field: 'Symbol', initialHide: true },
  { type: 'subAccount', field: 'TradeSubAccount', initialHide: false },
  { type: 'subAccount', field: 'HedgeSubAccount', initialHide: false },
];
